import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import logo from '../assets/logo_copiaazul.png';
import './DocsPage.css';  // We'll reuse the docs page styling
import { CSSTransition } from 'react-transition-group';
import '../styles/Transitions.css';

const ManualPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <CSSTransition
      in={true}
      appear={true}
      timeout={400}
      classNames="page-transition"
    >
      <div className="docs-container">
        <nav className="nav-bar">
          <div className="nav-brand">
            <Link to="/" className="brand-link">
              <img src={logo} alt="WCAIS Logo" className="nav-logo" />
              <span className="nav-title" style={{
                background: 'linear-gradient(to bottom, #ffffff, #66f2f2)',
                WebkitBackgroundClip: 'text',
                backgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                display: 'inline-block'
              }}>What-can-AI-see?</span>
            </Link>
          </div>

          <Link to="/app" className="get-started-btn">Get started</Link>
        </nav>

        <div className="docs-content">
          <div className="markdown-content">
            <h1>User Manual</h1>
            
            <h2>Getting Started</h2>
            <h3>1. Accessing the Tool</h3>
            <p>Open the web interface in your browser. Ensure your microphone and webcam (if used) are properly connected and permitted for use.</p>

            <h3>2. Image Input</h3>
            <ul>
              <li><strong>Using Webcam</strong>:
                <ol>
                  <li>Webcam mode is activated by default.</li>
                  <li>Adjust the camera until the desired scene or object is clearly visible.</li>
                  <li>After asking a question, capture the image by clicking the "Submit" button.</li>
                </ol>
              </li>
              <li><strong>Uploading an Image</strong>:
                <ol>
                  <li>Click on the "Upload Image" option.</li>
                  <li>Select an image from your device.</li>
                  <li>The image will be displayed on the screen for review.</li>
                </ol>
              </li>
            </ul>

            <hr />

            <h2>Asking a Question</h2>
            <ol>
              <li><strong>Adjust Settings (Optional)</strong>
                <ul>
                  <li>Use the sliders to set your preferred:
                    <ul>
                      <li><strong>Context Sensitivity</strong>: Controls how much context the model uses to understand your question.</li>
                      <li><strong>Confidence Level</strong>: Sets the minimum confidence required for the model to provide an answer.</li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li><strong>Start Talking</strong>
                <ul>
                  <li>Press the "Start" button to activate voice input.</li>
                  <li>Clearly ask your question about the image. For example:
                    <ul>
                      <li>"What is happening in this image?"</li>
                      <li>"Is there any text? If so, what does it say?"</li>
                    </ul>
                  </li>
                  <li>The tool detects when you stop talking and automatically submits the question.</li>
                </ul>
              </li>
              <li><strong>Listening to the Response</strong>
                <ul>
                  <li>The AI will analyze the image and your question.</li>
                  <li>The answer will be played back as speech.</li>
                </ul>
              </li>
            </ol>

            <hr />

            <h2>Tips for Best Results</h2>
            <ul>
              <li>Speak clearly and concisely when asking your question.</li>
              <li>Adjust the <strong>Context Sensitivity</strong> slider if the model's answers seem too general or overly detailed.</li>
              <li>Lower the <strong>Confidence Level</strong> if the model is not providing answers frequently.</li>
              <li>Ensure good lighting when using the webcam for better image quality.</li>
            </ul>

            <hr />

            <h2>Troubleshooting</h2>
            <ul>
              <li><strong>No response after asking a question</strong>:
                <ul>
                  <li>Check your internet connection.</li>
                  <li>Verify that your microphone is working and properly configured.</li>
                </ul>
              </li>
              <li><strong>Poor image quality</strong>:
                <ul>
                  <li>Ensure proper lighting and avoid glare or reflections.</li>
                  <li>Adjust your webcam position or try uploading a clearer image.</li>
                </ul>
              </li>
              <li><strong>Unclear answers</strong>:
                <ul>
                  <li>Adjust the Context Sensitivity or Confidence Level sliders for more accurate results.</li>
                </ul>
              </li>
            </ul>

            <hr />

            <h2>Privacy and Security</h2>
            <ul>
              <li>Images and voice data are processed securely.</li>
              <li>No personal data is stored after the interaction is completed.</li>
              <li>For detailed information, please contact us to <a href="#">WCAISEE@support.com</a>.</li>
            </ul>

            <hr />

            <h2>Updates and Improvements</h2>
            <p>This tool is continually evolving with new features and enhancements. Stay updated by visiting our website regularly.</p>

            <hr />

            <p>Thank you for using <strong>What-can-AI-see</strong>. We are dedicated to empowering visually impaired individuals with cutting-edge technology.</p>
          </div>
        </div>
      </div>
    </CSSTransition>
  );
};

export default ManualPage; 